export const formTypes = {
    feedback: 0,
    requestAccess: 1,
};